/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    Subscription: ''
  },
  mutations: {
    setModulesData (state, {Subscription}) {
      state.Subscription = Subscription
    },
    reset(state){
      state.Subscription=''
    }
  },
  actions: {
    getSubscriptionInformation ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/subscription')
        .then((response) => {
          var Subscription = response.data
          commit('setModulesData', {Subscription})
          resolve(Subscription)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getClassDetails(id){

    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/AdminProfile.js